export const url_CarregarDados_ID = '/agendasala/carregar/:idagendasala/:id_clinica';

